module.exports = __webpack_public_path__ + "media/assets/icons/close-sidebar-2a315d3c80ee6de248bbfbd23b189b36.svg";